import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Trash, DownloadSimple } from "@phosphor-icons/react";
import { Uploader } from "@/components/medicao/FotosManager";
import { errMsg, fetchBlobUrl, fmtDateTime } from "@/lib/medicoes";

const DOC_ACCEPT = ".pdf,.xlsx,.docx,.csv";

async function baixar(d) {
  try {
    const url = await fetchBlobUrl(`/medicoes/arquivos/${d.id}`);
    const a = document.createElement("a");
    a.href = url; a.download = d.original_filename || "documento"; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch { toast.error("Falha ao baixar documento"); }
}

export default function DocumentosManager({ medicaoId, docs = [], editable, onChange }) {
  const remove = async (d) => {
    if (!window.confirm(`Remover o documento ${d.original_filename}?`)) return;
    try { await api.delete(`/fornecedor/medicoes/${medicaoId}/arquivos/${d.id}`); onChange?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="docs-manager">
      {editable && (
        <div className="flex flex-wrap gap-2 items-center">
          <Uploader medicaoId={medicaoId} tipo="documento" accept={DOC_ACCEPT} onDone={onChange} testid="doc-upload-btn">
            <FileText size={16} /> Anexar documentos
          </Uploader>
          <span className="text-[11px] text-[#64748B]">PDF, XLSX, DOCX, CSV · até 20 MB</span>
        </div>
      )}
      {!docs.length && <p className="text-sm text-[#94A3B8]">Nenhum documento complementar.</p>}
      {docs.map((d, i) => (
        <div key={d.id} data-testid={`doc-row-${i}`} className="flex items-center gap-3 rounded border border-[#334155] px-3 py-2">
          <FileText size={18} className="text-[#FFDF00] shrink-0" />
          <div className="min-w-0 flex-1">
            <div className="text-sm truncate">{d.original_filename}</div>
            <div className="text-[10px] text-[#64748B]">{(d.size / 1024).toFixed(0)} KB · {fmtDateTime(d.created_at)} · SHA-256 {d.sha256?.slice(0, 12)}…</div>
          </div>
          <button type="button" onClick={() => baixar(d)} data-testid={`doc-download-${i}`} className="p-1.5 rounded border border-[#334155] hover:border-[#FFDF00]"><DownloadSimple size={14} /></button>
          {editable && <button type="button" onClick={() => remove(d)} data-testid={`doc-del-${i}`} className="p-1.5 rounded border border-[#EF4444]/40 text-[#EF4444]"><Trash size={14} /></button>}
        </div>
      ))}
    </div>
  );
}
